import { render, staticRenderFns } from "./importthetopic.vue?vue&type=template&id=a7b24dfc&scoped=true"
import script from "./importthetopic.vue?vue&type=script&lang=js"
export * from "./importthetopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b24dfc",
  null
  
)

export default component.exports